import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResponseBase } from '../models/response-base';
import { CollaboratorType } from '../models/collaborator-type';

@Injectable({
  providedIn: 'root'
})
export class CollaboratorTypeService {

  API: string = environment.GATEWAY + 'collaborator/collaboratorType';

  constructor(private http: HttpClient) { }

  get() {
    let headers = new HttpHeaders();
    headers = headers.append('no-loader', 'true');
    return this.http.get<ResponseBase<CollaboratorType[]>>(`${this.API}/get`,{headers});
  }

}
